var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmartTasksActive = function SvgSmartTasksActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    fillRule: "evenodd",
    d: "M7.416 3A4.983 4.983 0 0 0 7 5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2c0-.711-.148-1.388-.416-2H18a2 2 0 0 1 2 2v15a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h1.416ZM12 14H9a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2Zm3-4H9a1 1 0 0 0-.117 1.993L9 12h6a1 1 0 0 0 0-2Zm-3-8a2.99 2.99 0 0 1 2.236 1c.428.478.704 1.093.755 1.772L15 5H9c0-.725.257-1.39.685-1.908L9.764 3c.55-.614 1.348-1 2.236-1Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M7 9h11v10H7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.535 10.18a.5.5 0 0 1 .93 0l.87 2.204a.5.5 0 0 0 .281.281l2.205.87a.5.5 0 0 1 0 .93l-2.205.87a.5.5 0 0 0-.281.281l-.87 2.205a.5.5 0 0 1-.93 0l-.87-2.205a.5.5 0 0 0-.281-.281l-2.205-.87a.5.5 0 0 1 0-.93l2.205-.87a.5.5 0 0 0 .281-.281l.87-2.205ZM15.814 8.472a.2.2 0 0 1 .372 0l.348.882a.2.2 0 0 0 .113.112l.881.348a.2.2 0 0 1 0 .372l-.881.348a.2.2 0 0 0-.113.112l-.348.882a.2.2 0 0 1-.372 0l-.348-.882a.2.2 0 0 0-.112-.112l-.882-.348a.2.2 0 0 1 0-.372l.882-.348a.2.2 0 0 0 .112-.112l.348-.882Z"
  })));
};
export default SvgSmartTasksActive;